<template>
    <Card :padding="20">
        <Row>
            <Col :span="item.width" v-for="(item,index) in data" :key="index" class="card-box">
                <div class="tc-data-card">
                    <div class="tc-data-card-hd">
                        <div class="text-label">
                            {{item.title}}
                        </div>
                    </div>
                    <div class="tc-data-card-bd">
                        <div class="tc-data-value">
                            <span class="tc-data-num">{{item.number}}</span>
                            <span>{{item.unit}}</span>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    </Card>
</template>

<script>
    export default {
        name: "cardTit",
        props:{
            data:Array,
        },
    }
</script>

<style scoped lang="less">
    .tc-data-card {
        border-right: 1px solid #e5e5e5;
        .tc-data-card-hd {
            margin-bottom: 10px;
            font-size: 14px;
            color: #444;
            .text-label {
                color: #888;
                font-size: 12px;
            }
        }
        .tc-data-value {
            font-size: 14px;
            .tc-data-num {
                font-size: 36px;
                margin-right: 5px;
            }
        }
    }
    .card-box{
        padding-left: 10px;
        padding-right: 10px;
    }

    .card-box:last-child .tc-data-card {
        border-right: 0;
    }

</style>